import { FormGroup, FormControlLabel, Checkbox } from "@material-ui/core";

export const CheckboxesGroup = ({ checkedValues, options, onChange }) => {
  const handleChange = (event) => {
    onChange({
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <FormGroup>
      {options.map((option, index) => (
        <FormControlLabel
          key={index}
          value={option}
          control={
            <Checkbox
              checked={checkedValues[option]}
              onChange={handleChange}
              name={option}
              color="primary"
            />
          }
          label={option}
        />
      ))}
    </FormGroup>
  );
};
